module.exports = __webpack_public_path__ + "static/assets/f50910239a65d61d18e883a07665247d.png";